import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-3 text-[0.68rem] font-medium uppercase tracking-[0.28em] text-[#B89B72] ${className}`}>
    <span className="h-px w-8 bg-[#B89B72]/60" />
    {children}
  </span>
);

export const Display = ({ children, className = "" }) => (
  <h2 className={`font-display font-light tracking-tight text-[#1A1A1A] ${className}`}>{children}</h2>
);

export const PillLink = ({ to, children, dark = false, testid, external = false }) => {
  const cls = `group inline-flex items-center gap-2 rounded-full px-7 py-3 text-sm tracking-wide transition-colors duration-500 ${dark ? "bg-[#1A1A1A] text-[#FAF9F6] hover:bg-[#B89B72]" : "border border-[#1A1A1A]/25 text-[#1A1A1A] hover:border-[#B89B72] hover:text-[#B89B72]"}`;
  if (external) return <a href={to} className={cls} data-testid={testid}>{children}</a>;
  return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
};
